import { getLocalServerOverrides } from '~/env';
import type { ServerBaseUrl } from './types';

/**
 * Applies the local development server url overrides (`VITE_LOCAL_*_SERVER`) to a server configuration
 *
 * Overrides that are unset or blank are ignored, so they can't clobber a configured url
 *
 * @see {@link file://./../env.ts}
 *
 * @param config - the server configuration to override
 * @returns a copy of the server configuration with the overrides applied
 */
export const applyLocalServerOverrides = (
    config: ServerBaseUrl
): ServerBaseUrl => {
    const envLocalServerOverrides = getLocalServerOverrides();
    const overrides = Object.entries(envLocalServerOverrides || {}).filter(
        ([, value]) => typeof value === 'string' && value.trim()
    );

    return { ...config, ...Object.fromEntries(overrides) };
};
